import { Component, Input, inject } from '@angular/core';
import { SearchSuggestion } from '@forgerock/backstage-ui-core';
import { SearchParamsContainerComponent } from '../search-params-container/search-params-container.component';

@Component({
  selector: 'app-did-you-mean',
  templateUrl: './did-you-mean.component.html',
  styleUrls: [ './did-you-mean.component.scss' ],
  standalone: true
})
export class DidYouMeanComponent {
  container = inject(SearchParamsContainerComponent);

  @Input() suggestions: SearchSuggestion[];
}
